import React from 'react';
import {
  PricesAccordionSection,
  PricesAccordionTab,
  PricesYearFilter,
  PricesTabType,
  PricesState,
  PricesBedsFilter,
} from 'store/state/selectors/insights/prices';
import { PaginationType } from 'ds/components/pagination';
import { Tabs } from 'ds/components/tabs';
import { Wrapper, TabsHeaderWrapper, TabsHeader } from './styled';
import TabHeader from './TabHeader';
import TabBody from './TabBody';
import { setAuthModal } from 'store/state/app/actions';
import { AuthenticationModalType } from 'components/authentication/types';
import { AuthModalSource } from 'store/state/app';


interface ListingsProps {
  activeTab: PricesTabType;
  setActiveTab: (tab: PricesTabType) => void;
  section: PricesAccordionSection;
  pricesState: PricesState;
  isProjectPage?: boolean;
  unitPageBulletinId?: string;
  showOnlyFinalTransactionsFilter: boolean;
  yearFilter: PricesYearFilter;
  bedsFilter: PricesBedsFilter;
  showTabs?: boolean;
  projectId?: string;
  projectIds?: string[];
  pricesTableChildren?: React.ReactNode;
  paginationType?: PaginationType;
  visibleRowsMobile?: number;
  visibleRowsDesktop?: number;
  isConnectedUser: boolean;
  onSetAuthModal: typeof setAuthModal;
}

const HeaderWrapper: React.FC = ({ children }) => (
  <TabsHeaderWrapper>
    <TabsHeader>
      {children}
    </TabsHeader>
  </TabsHeaderWrapper>
);

const Listings: React.FC<ListingsProps> = ({
  showOnlyFinalTransactionsFilter,
  unitPageBulletinId,
  setActiveTab,
  yearFilter,
  bedsFilter,
  activeTab,
  section,
  isProjectPage = false,
  showTabs = true,
  projectId,
  projectIds,
  pricesTableChildren,
  paginationType,
  visibleRowsMobile,
  visibleRowsDesktop,
  isConnectedUser,
  onSetAuthModal,
}) => {
  if (!section) return null;
  const { tabs } = section;
  const [ firstTab ] = tabs;
  if (!firstTab) return null;

  return (
    <Wrapper data-auto="sold-listings-table">
      {showTabs ? (
        <Tabs
          activeTab={tabs.findIndex( ({ tabId }) => tabId === activeTab)}
          setActiveTab={(idx: number) => {
            if (!isConnectedUser && idx !== 0) {
              onSetAuthModal({ type: AuthenticationModalType.GatedDeals }, { source: AuthModalSource.DealsGateTab });
            }
            else {
              setActiveTab(tabs[idx].tabId);
            }
          }}
          headers={tabs.map((tab: PricesAccordionTab) => (
            <TabHeader
              key={tab.tabId}
              tab={tab}
              activeTab={activeTab}
              isProjectPage={isProjectPage}
              currentBulletinId={unitPageBulletinId}
            />
          ))}
          headerWrapper={HeaderWrapper}
          bodies={tabs.map((tab) => (
            <TabBody
              key={tab.tabId}
              tab={tab}
              sectionId={section.sectionId}
              currentBulletinId={unitPageBulletinId}
              showOnlyFinalTransactionsFilter={showOnlyFinalTransactionsFilter}
              yearFilter={yearFilter}
              bedsFilter={bedsFilter}
              projectId={projectId}
              projectIds={projectIds}
              paginationType={paginationType}
              visibleRowsMobile={visibleRowsMobile}
              visibleRowsDesktop={visibleRowsDesktop}
              pricesTableChildren={pricesTableChildren}
            />
          ))}
        />
      ) : (
        <TabBody
          key={firstTab.tabId}
          tab={firstTab}
          sectionId={section.sectionId}
          currentBulletinId={unitPageBulletinId}
          showOnlyFinalTransactionsFilter={showOnlyFinalTransactionsFilter}
          yearFilter={yearFilter}
          bedsFilter={bedsFilter}
          projectId={projectId}
          projectIds={projectIds}
        />
      )}
    </Wrapper>
  );
};

export default Listings;
